export default "__VITE_ASSET__BpLbb2Oi__"